import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

// @param scheduleData: object
// example:
// {
//   "is_active": false,
//   "schedule_slots_attributes": [
//     {
//         "day_of_the_week": "sunday",
//         "start_time": "10:00",
//         "end_time": "11:00"
//     }
//   ]
// }
export function createTutorSchedule(
  scheduleData: object
): Promise<ApiResponse> {
  return Axios.post("v1/tutors/schedules", scheduleData);
}
export function indexTutorStudentSchedules(
  id: string | number
): Promise<ApiResponse> {
  return Axios.get(`v1/tutors/schedules?student_id=${id}`);
}
// @param scheduleData: object
// example:
// {
//   "is_active": false,
//   "schedule_slots_attributes": [
//     {
//         "id": 2
//         "day_of_the_week": "sunday",
//         "start_time": "10:00",
//         "end_time": "11:00"
//     }
//   ]
// }
export function updateTutorSchedule(
  scheduleData: object
): Promise<ApiResponse> {
  return Axios.post(
    `v1/tutors/proposed_schedules/create_tutor_schedule_request_group`,
    scheduleData
  );
}

export function indexTutorSchedules(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("/v2/tutors/schedules", { params });
}
export function indexTutorSchedulesDateRange(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("/v2/tutors/schedules", { params });
}

export function currentTutorSchedules(): Promise<ApiResponse> {
  return Axios.get("/v1/tutors/schedules/current");
}
export function requestTutorScheduleGroup(): Promise<ApiResponse> {
  return Axios.post(`v1/tutors/schedules/`);
}
